import React from 'react';

interface Props {
    children: string;
}

const Ajuda = ({ children }: Props): React.ReactElement =>
{
    return (
        <small className="form-text text-muted">
            { children }
        </small>
    );
}

export default Ajuda;
